import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import App from "./App";
import { store } from "./store";
import { ThemeProvider } from "./contexts/ThemeContext";

const root = createRoot(document.getElementById("root") as HTMLElement);
const basename =
  process.env.PUBLIC_URL && process.env.PUBLIC_URL !== "."
    ? process.env.PUBLIC_URL
    : undefined;

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <BrowserRouter basename={basename}>
          <Routes>
            <Route path="/dir/:directoryId" element={<App />} />
            <Route path="/" element={<App />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

serviceWorker.unregister();
